import { ReactNode, useEffect, useState } from 'react'
import { oembed } from '@loomhq/loom-embed'
import { OEmbedInterface } from '@loomhq/loom-embed/dist/.types/oembed'
import { Loader } from 'shared/components/loader'
import { EmbeddedVideoAttachment } from 'modules/community/types/post-attachment'

export interface EmbeddedLoomGalleryPreviewProps {
  attachment: EmbeddedVideoAttachment
}

const EmbeddedLoomGalleryPreview = ({ attachment }: EmbeddedLoomGalleryPreviewProps): ReactNode => {
  const [loomMetadata, setLoomMetadata] = useState<OEmbedInterface>()

  useEffect(() => {
    const fetchLoomMetadata = async (): Promise<void> => {
      if (!attachment.url) return

      const metadata = await oembed(attachment.url)
      setLoomMetadata(metadata)
    }

    fetchLoomMetadata()
  }, [attachment.url])

  if (!attachment.url || !loomMetadata) return <Loader />

  return (
    <article
      key={attachment.id}
      className="inline-flex size-full shrink-0 snap-center justify-center px-20 py-10 lg:aspect-video lg:p-40"
    >
      <div
        className="size-full lg:aspect-4/3 lg:w-fit"
        dangerouslySetInnerHTML={{ __html: loomMetadata.html }}
      />
    </article>
  )
}

export default EmbeddedLoomGalleryPreview
